import React, { useEffect, useState } from 'react';
import { NotificationCard, NotificationTimeIndicator } from '@fsd-entities/online-lessons';
import { useNotificationTimer } from '@fsd-features/online-lessons';

import { INotificationItemProps } from './NotificationItem.types';

import './NotificationItem.style.scss';
export const NotificationItem = React.memo<INotificationItemProps>((props) => {
    const { notification, isCollapsed, handleMeetingFinished, handleCollapseNotification } = props;
    const [isNotificationCollapsed, setIsNotificationCollapsed] = useState(isCollapsed);
    const [isCollapsedByClickOnce, setIsCollapsedByClickOnce] = useState(false);
    let timer: NodeJS.Timeout;
    const { isMeetingStarted, isMeetingFinished, time } = useNotificationTimer({
        startTime: notification.datetimeStart,
        endTime: notification.datetimeEnd,
    });

    const handleMouseEnter = () => {
        if (timer) {
            clearTimeout(timer);
        }
        if (isCollapsedByClickOnce) {
            setIsNotificationCollapsed(false);
        }
    };

    const handleMouseLeave = () => {
        if (isCollapsedByClickOnce) {
            timer = setTimeout(() => {
                setIsNotificationCollapsed(true);
            }, 100);
        }
    };

    const handleClickLocal = () => {
        if (!isCollapsedByClickOnce) {
            setIsCollapsedByClickOnce(true);
            handleCollapseNotification();
        }
    };

    useEffect(() => {
        if (isMeetingFinished) {
            handleMeetingFinished();
        }
    }, [isMeetingFinished]);

    useEffect(() => {
        setIsNotificationCollapsed(isCollapsed);
        if (isCollapsed) {
            setIsCollapsedByClickOnce(true);
        }
    }, [isCollapsed]);
    return (
        <div
            className={'notification-item'}
            onMouseEnter={isCollapsedByClickOnce ? handleMouseEnter : undefined}
            onMouseLeave={isCollapsedByClickOnce ? handleMouseLeave : undefined}
        >
            <NotificationTimeIndicator
                isCollapsed={isNotificationCollapsed}
                isMeetingStarted={isMeetingStarted}
                isMeetingFinished={isMeetingFinished}
                time={time}
            />
            <NotificationCard
                data={notification}
                isCollapsed={isNotificationCollapsed}
                isMeetingStarted={isMeetingStarted}
                handleCollapseBtnClick={handleClickLocal}
            />
        </div>
    );
});
